export const candidateConstants = {
  CREATE_CANDIDATE: "CREATE_CANDIDATE",
  UPDATE_CANDIDATE: "UPDATE_CANDIDATE",
  GET_CANDIDATES: "GET_CANDIDATES",
  GET_CANDIDATE_BY_ID: "GET_CANDIDATE_BY_ID",
  DELETE_CANDIDATE: "DELETE_CANDIDATE",
  GET_CANDIDATES_LIST: "GET_CANDIDATES_LIST"
};
